import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../services/hooks/auth";

import {
  createBrowserRouter,
  RouterProvider as ReactRouterProvider,
} from "react-router-dom";

import { AppRoutes } from "./routes";

const ProtectedRoute = ({ redirectPath = "/", children }: any) => {
  const { isAuthenticated } = useAuth();

  const authenticated = isAuthenticated();

  if (!authenticated?.id) {
    return <Navigate to={redirectPath} replace />;
  }

  return children || <Outlet />;
};

export { ProtectedRoute };

const router = createBrowserRouter(AppRoutes);

export function RouterProvider() {
  return <ReactRouterProvider router={router} />;
}
